import React, { useCallback, useEffect, useMemo, useState } from 'react';
import ReactDOM from 'react-dom';
import usePrevious from './use-previous';

export interface PdpProps {
    children: any;
    selector: any;
}

const Portal = ({ children, selector }: PdpProps) => {
    const prevSelector = usePrevious(selector);
    const prevChild = usePrevious(children);
    const domNode = document.getElementById(selector);

    if (!domNode) {
        return null;
    }
    if (prevSelector != selector) {
        domNode.innerHTML = '';
    }

    return ReactDOM.createPortal(<>{children}</>, domNode);
};

export default Portal;
